module.exports = __webpack_public_path__ + "img/card-1.191e494c.png";